import { render, staticRenderFns } from "./RecommendedPage.vue?vue&type=template&id=56528e5e&scoped=true&"
import script from "./RecommendedPage.vue?vue&type=script&lang=js&"
export * from "./RecommendedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56528e5e",
  null
  
)

export default component.exports